import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface Post{
  id: number,
  title: string,
  body?: string,
  excerpt?: string ,
  views: number,
  image?: string,
  tags?: string,
  is_premium: boolean,
  create_date: string,
  update_date: string,
  status: string,
  cat_id?: number,
  BlogCategory: {
      name: string
  }
  NextPost : Post,
  PrePost : Post
}

export interface PostRes{
  post: Post,
  last_posts: Array<object>,
  categories: Array<object>
}

export interface BlogAll{
  posts: Post[],
  last_posts: Array<object>,
  faq: Array<object>,
  categories: Array<object>
}

export const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/blog',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['blog','post'],

  endpoints: (builder) => ({
    getAllBlogs: builder.query<BlogAll,void>({
      query: () => 'all',
      providesTags: ['blog']
    }),
    getPost: builder.query<PostRes,number>({
      query: (id) => `post/${id}`,
      providesTags: ['post']
    }),
    getLastSixBlogs: builder.query<Post[],void>({
      query: () => 'lastSix',
      providesTags: ['blog']
    }),
  }),
})

export const { useGetAllBlogsQuery, useGetLastSixBlogsQuery, useGetPostQuery } = blogApi
